<template>
  <v-container id="app-settings" fluid>
    <v-row align="center" justify="center">
			<v-col cols="12">
				<v-expansion-panels>
    			<v-expansion-panel>
						<v-expansion-panel-header>Roles</v-expansion-panel-header>
						<v-expansion-panel-content>
							<v-card-actions>
								<v-spacer />
							</v-card-actions>
							<v-data-table :headers="rolesHeaders" :items="getRoleList" loading-text="Loading Roles..." :footer-props="{itemsPerPageOptions: [10], showFirstLastPage: true}" class="elevation-1">					
								<template v-slot:item.permission="{ item }">
									<div v-if="item.permissions.data.length <= 5">
										<v-chip v-for="permission in item.permissions.data" :key="permission.id" outlined pill>{{ permission.name }}</v-chip>
									</div>
									<div v-else>
										<v-chip v-for="n in 5" :key="item.permissions.data[n-1].id" outlined pill>{{ item.permissions.data[n-1].name }}</v-chip>
										<span class="grey--text text-caption">(+{{ item.permissions.data.length - 5 }} roles)</span>
									</div>
								</template>
								<template v-slot:item.actions="{ item }">
									<v-icon small @click.prevent="openEditRoleDialog(item)">edit</v-icon>
								</template>
							</v-data-table>

							<v-dialog v-model="editRoleDialogShow" persistent max-width="500px">
								<v-card>
									<v-card-title>
										<span class="headline">Role</span>
									</v-card-title>
									<v-card-text>
										<v-alert :value="editRoleAlert.show" dense outlined type="error" icon="error">{{ editRoleAlert.message }}</v-alert>
										<v-progress-linear :active="editDialogLoading" height="3" indeterminate absolute color="primary" />
										<v-container>
											<v-form ref="editRoleDialogForm">
												<v-row>
													<v-col cols="12">
														<v-text-field v-model="editedRole.name" label="Name" type="text" autocomplete="off" disabled />
													</v-col>
													<v-col cols="12">
														<v-select v-model="editedRole.permissions.data" :items="getPermssionList" item-value="id" item-text="name" label="User Roles" :rules="[...getRlDialogRules.requiredArray]" multiple chips clearable clear-icon="close" />
													</v-col>
												</v-row>
											</v-form>
										</v-container>
									</v-card-text>
									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn color="primary darken-1" text @click.prevent="editRoleDialogShow = false">Close</v-btn>
										<v-btn color="primary" @click.prevent="editRole()">Save</v-btn>
									</v-card-actions>
								</v-card>
							</v-dialog>
						</v-expansion-panel-content>
    			</v-expansion-panel>

					<v-expansion-panel>
						<v-expansion-panel-header>Licenses</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-card-actions>
									<v-spacer />
									<v-btn cols="4" color="primary" @click.prevent="openAddLicensesDialog()">Add License</v-btn>
								</v-card-actions>
								<v-data-table :headers="licensesHeaders" :items="getLicenseList" loading-text="Loading Licenses..." :footer-props="{itemsPerPageOptions: [10], showFirstLastPage: true}" class="elevation-1">
								<template v-slot:item.actions="{ item }">
									<v-icon small @click.prevent="openEditLicensesDialog(item)">edit</v-icon>								
									<v-icon small @click.prevent="openDeleteDialog('License', 'licenses', 'setLicenseList', item)">delete</v-icon>
								</template>
								<template v-slot:item.roles="{ item }">					
									<v-chip v-for="role in item.roles.data" :key="role.id" outlined pill>{{ role.name }}</v-chip>
								</template>
							</v-data-table>

							<v-dialog v-model="editLicenseDialogShow" persistent max-width="500px">
								<v-card>
									<v-card-title>
										<span class="headline">License</span>
									</v-card-title>
									<v-card-text>
										<v-alert :value="editLicenseAlert.show" dense outlined type="error" icon="error">{{ editLicenseAlert.message }}</v-alert>
										<v-progress-linear :active="editDialogLoading" height="3" indeterminate absolute color="primary" />
										<v-container>
											<v-form ref="editLicenseDialogForm">
												<v-row> 
													<v-col cols="12">
														<v-text-field v-model="editedLicense.name" :rules="[...getRlDialogRules.required, ...getRlDialogRules.stringMax255]" label="Name" type="text" autocomplete="off" />
													</v-col>
													<v-col cols="12">
														<v-text-field v-model="editedLicense.duration" :rules="[...getRlDialogRules.required, ...getRlDialogRules.isInteger]" label="Duration" type="number" autocomplete="off" />
													</v-col>
													<v-col cols="12">
														<v-select v-model="editedLicense.roles.data" :items="getRoleList" item-value="id" item-text="name" label="User Roles" :rules="[...getRlDialogRules.requiredArray]" multiple chips clearable clear-icon="close" />									
													</v-col>
												</v-row>
											</v-form>
										</v-container>
									</v-card-text>
									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn color="primary darken-1" text @click.prevent="editLicenseDialogShow = false">Close</v-btn>
										<v-btn color="primary" @click.prevent="editLicense()">Save</v-btn>
									</v-card-actions>
								</v-card>
							</v-dialog>
							
							<v-dialog v-model="addLicenseDialogShow" persistent max-width="500px">
								<v-card>
									<v-card-title>
										<span class="headline">License</span>
									</v-card-title>
									<v-card-text>
										<v-alert :value="addLicenseAlert.show" dense outlined type="error" icon="error">{{ addLicenseAlert.message }}</v-alert>
										<v-progress-linear :active="addDialogLoading" height="3" indeterminate absolute color="primary" />
										<v-container>
											<v-form ref="addLicenseDialogForm">
												<v-row>
													<v-col cols="12">
														<v-text-field v-model="addedLicense.name" :rules="[...getRlDialogRules.required, ...getRlDialogRules.stringMax255]" label="Name" type="text" autocomplete="off" />
													</v-col>
													<v-col cols="12">
														<v-text-field v-model="addedLicense.duration" :rules="[...getRlDialogRules.required, ...getRlDialogRules.isInteger]" label="Duration" type="number" autocomplete="off" />
													</v-col>
												</v-row>
												<v-row>
													<v-col cols="12">
														<v-select v-model="addedLicense.roles" :items="getRoleList" item-value="id" item-text="name" label="User Roles" :rules="[...getRlDialogRules.requiredArray]" multiple chips clearable clear-icon="close" />
													</v-col>
												</v-row>
											</v-form>
									</v-container>
								</v-card-text>
								<v-card-actions>
									<v-spacer></v-spacer>
									<v-btn color="primary darken-1" text @click.prevent="closeAddLicenseDialog()">Close</v-btn>
									<v-btn color="primary" @click.prevent="addLicense()">Save</v-btn>
								</v-card-actions>
							</v-card>
							</v-dialog> 

						</v-expansion-panel-content>
					</v-expansion-panel>

					<v-expansion-panel>
						<v-expansion-panel-header>Currencies</v-expansion-panel-header>
						<v-expansion-panel-content>
							<v-card-actions>
								<v-spacer />
								<v-btn cols="4" color="primary" @click.prevent="openAddDialog('Currency', 'currencyHeaders', 'currencies', 'setCurrencyList')">Add Currency</v-btn>
							</v-card-actions>
							<v-data-table :headers="currencyHeaders" :items="getCurrencyList" loading-text="Loading Currencies..." :footer-props="{itemsPerPageOptions: [10], showFirstLastPage: true}" class="elevation-1">
								<template v-slot:item.actions="{ item }">
								<v-icon small @click.prevent="openEditDialog('Currency', 'currencyHeaders', 'currencies', 'setCurrencyList', item)">edit</v-icon>
								<v-icon small @click.prevent="openDeleteDialog('Currency', 'currencies', 'setCurrencyList', item)">delete</v-icon>
								</template>
							</v-data-table>
						</v-expansion-panel-content>
					</v-expansion-panel>

					<v-expansion-panel>
						<v-expansion-panel-header>Countries</v-expansion-panel-header>
						<v-expansion-panel-content>
							<v-card-actions>
							<v-spacer />
							<v-btn cols="4" color="primary" @click.prevent="openAddDialog('Country', 'countryHeaders', 'countries', 'setCountryList')">Add Country</v-btn>
							</v-card-actions>
							<v-data-table :headers="countryHeaders" :items="getCountryList" loading-text="Loading Countries..." :footer-props="{itemsPerPageOptions: [10], showFirstLastPage: true}" class="elevation-1">
								<template v-slot:item.actions="{ item }">
									<v-icon small @click.prevent="openEditDialog('Country', 'countryHeaders', 'countries', 'setCountryList', item)">edit</v-icon>
									<v-icon small @click.prevent="openDeleteDialog('Country', 'countries', 'setCountryList', item)">delete</v-icon>
								</template>
							</v-data-table>
						</v-expansion-panel-content>
					</v-expansion-panel>

					<v-expansion-panel>
						<v-expansion-panel-header>Entry Types</v-expansion-panel-header>
						<v-expansion-panel-content>
							<v-card-actions>
							<v-spacer />
							<v-btn cols="4" color="primary" @click.prevent="openAddDialog('Entry Type', 'entryTypeHeaders', 'entryTypes', 'setEntryTypeList')">Add Entry Type</v-btn>
							</v-card-actions>
							<v-data-table :headers="entryTypeHeaders" :items="getEntryTypeList" loading-text="Loading Entry Types..." :footer-props="{itemsPerPageOptions: [10], showFirstLastPage: true}" class="elevation-1">
								<template v-slot:item.actions="{ item }">
								<v-icon small @click.prevent="openEditDialog('Entry Type', 'entryTypeHeaders', 'entryTypes', 'setEntryTypeList', item)">edit</v-icon>
								<v-icon small @click.prevent="openDeleteDialog('Entry Type', 'entryTypes', 'setEntryTypeList', item)">delete</v-icon>
								</template>
							</v-data-table>
						</v-expansion-panel-content>
					</v-expansion-panel>

					<v-expansion-panel>
						<v-expansion-panel-header>Materials</v-expansion-panel-header>
						<v-expansion-panel-content>
							<v-card-actions>
							<v-spacer />
							<v-btn cols="4" color="primary" @click.prevent="openAddDialog('Material', 'materialHeaders', 'materials', 'setMaterialList')">Add Material</v-btn>
							</v-card-actions>
							<v-data-table :headers="materialHeaders" :items="getMaterialList" loading-text="Loading Materials..." :footer-props="{itemsPerPageOptions: [10], showFirstLastPage: true}" class="elevation-1">
								<template v-slot:item.actions="{ item }">
								<v-icon small @click.prevent="openEditDialog('Material', 'materialHeaders', 'materials', 'setMaterialList', item)">edit</v-icon>
								<v-icon small @click.prevent="openDeleteDialog('Material', 'materials', 'setMaterialList', item)">delete</v-icon>
								</template>
							</v-data-table>
						</v-expansion-panel-content>
					</v-expansion-panel>

					<v-expansion-panel>
						<v-expansion-panel-header>Grades</v-expansion-panel-header>
						<v-expansion-panel-content>
							<v-card-actions>
							<v-spacer />
							<v-btn cols="4" color="primary" @click.prevent="openAddDialog('Grade', 'gradeHeaders', 'grades', 'setGradeList')">Add Grade</v-btn>
							</v-card-actions>
							<v-data-table :headers="gradeHeaders" :items="getGradeList" loading-text="Loading Grades..." :footer-props="{itemsPerPageOptions: [10], showFirstLastPage: true}" class="elevation-1">
								<template v-slot:item.material_id="{ item }">
									{{ getMaterialById(item.material_id) }}
								</template>
								<template v-slot:item.actions="{ item }">
									<v-icon small @click.prevent="openEditDialog('Grade', 'gradeHeaders', 'grades', 'setGradeList', item)">edit</v-icon>
									<v-icon small @click.prevent="openDeleteDialog('Grade', 'grades', 'setGradeList', item)">delete</v-icon>
								</template>
							</v-data-table>
						</v-expansion-panel-content>
					</v-expansion-panel>

					<v-expansion-panel>
						<v-expansion-panel-header>Incoterms</v-expansion-panel-header>
						<v-expansion-panel-content>
							<v-card-actions>
							<v-spacer />
							<v-btn cols="4" color="primary" @click.prevent="openAddDialog('Incoterm', 'incotermHeaders', 'incoterms', 'setIncotermList')">Add Incoterm</v-btn>
							</v-card-actions>
							<v-data-table :headers="incotermHeaders" :items="getIncotermList" loading-text="Loading Incoterms..." :footer-props="{itemsPerPageOptions: [10], showFirstLastPage: true}" class="elevation-1">
								<template v-slot:item.actions="{ item }">
								<v-icon small @click.prevent="openEditDialog('Incoterm', 'incotermHeaders', 'incoterms', 'setIncotermList', item)">edit</v-icon>
								<v-icon small @click.prevent="openDeleteDialog('Incoterm', 'incoterms', 'setIncotermList', item)">delete</v-icon>
								</template>
							</v-data-table>
						</v-expansion-panel-content>
					</v-expansion-panel>

					<v-expansion-panel>
						<v-expansion-panel-header>PBI Reports</v-expansion-panel-header>
						<v-expansion-panel-content>
							<v-card-actions>
							<v-spacer />
							<v-btn cols="4" color="primary" @click.prevent="openAddDialog('PBI Report', 'pbiReportHeaders', 'pbiReports', 'setPBIReportList')">Add PBI Report</v-btn>
							</v-card-actions>
							<v-data-table :headers="pbiReportHeaders" :items="getPBIReportList" loading-text="Loading PBI Reports..." :footer-props="{itemsPerPageOptions: [10], showFirstLastPage: true}" class="elevation-1">
								<template v-slot:item.actions="{ item }">
									<v-icon small @click.prevent="openEditDialog('PBI Report', 'pbiReportHeaders', 'pbiReports', 'setPBIReportList', item)">edit</v-icon>
									<v-icon small @click.prevent="openDeleteDialog('PBI Report', 'pbiReports', 'setPBIReportList', item)">delete</v-icon>
								</template>							
							</v-data-table>
						</v-expansion-panel-content>
					</v-expansion-panel>

					<v-expansion-panel>
						<v-expansion-panel-header>Units of Measure</v-expansion-panel-header>
						<v-expansion-panel-content>
							<v-card-actions>
							<v-spacer />
							<v-btn cols="4" color="primary" @click.prevent="openAddDialog('Unit of Measure', 'unitOfMeasureHeaders', 'unitsOfMeasure', 'setUnitOfMeasureList')">Add Unit of Measure</v-btn>
							</v-card-actions>
							<v-data-table :headers="unitOfMeasureHeaders" :items="getUnitOfMeasureList" loading-text="Loading Units of Measure..." :footer-props="{itemsPerPageOptions: [10], showFirstLastPage: true}" class="elevation-1">
								<template v-slot:item.actions="{ item }">
								<v-icon small @click.prevent="openEditDialog('Unit of Measure', 'unitOfMeasureHeaders', 'unitsOfMeasure', 'setUnitOfMeasureList', item)">edit</v-icon>
								<v-icon small @click.prevent="openDeleteDialog('Unit of Measure', 'unitsOfMeasure', 'setUnitOfMeasureList', item)">delete</v-icon>
								</template>
							</v-data-table>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-expansion-panels>

				<v-dialog v-if="addDialogShow" v-model="addDialogShow" persistent max-width="500px">
					<v-card>
						<v-card-title>
							<span class="headline">{{ addDialogTitle }}</span>
						</v-card-title>
						<v-card-text>
							<v-alert :value="addDialogAlert.show" dense outlined type="error" icon="error">{{ addDialogAlert.message }}</v-alert>
							<v-progress-linear :active="addDialogLoading" height="3" indeterminate absolute color="primary" />
							<v-container>
								<v-form ref="addDialogForm">
									<v-row v-for="item in addDialogFields" :key="item.value">
										<v-col v-if="item.type == 'text'" cols="12">
											<v-text-field v-model="addDialogItem[item.value]" :label="item.text" :rules="item.rules.map(x => {return {...getRlDialogRules[x]}[0]})" type="text" autocomplete="off" />
										</v-col>
										<v-col v-if="item.type == 'number'" cols="12">
											<v-text-field v-model="addDialogItem[item.value]" :label="item.text" :rules="item.rules.map(x => {return {...getRlDialogRules[x]}[0]})" type="number" autocomplete="off" />
										</v-col>
										<v-col v-if="item.type == 'select-material'" cols="12">
											<v-select v-model="addDialogItem[item.value]" :items="getMaterialList" item-value="id" item-text="description" :label="item.text" :rules="item.rules.map(x => {return {...getRlDialogRules[x]}[0]})" />
										</v-col>
									</v-row>
								</v-form>
							</v-container>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="primary darken-1" text @click.prevent="addDialogShow = false" :disabled="addDialogLoading">Close</v-btn>
							<v-btn color="primary" @click.prevent="saveAddDialog()" :disabled="addDialogLoading">Save</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>

				<v-dialog v-if="editDialogShow" v-model="editDialogShow" persistent max-width="500px">
					<v-card>
						<v-card-title>
							<span class="headline">{{ editDialogTitle }}</span>
						</v-card-title>
						<v-card-text>
							<v-alert :value="editDialogAlert.show" dense outlined type="error" icon="error">{{ editDialogAlert.message }}</v-alert>
							<v-progress-linear :active="editDialogLoading" height="3" indeterminate absolute color="primary" />
							<v-container>
								<v-form ref="editDialogForm">
									<v-row v-for="item in editDialogFields" :key="item.value">
										<v-col v-if="item.type == 'text'" cols="12">
											<v-text-field v-model="editDialogItem[item.value]" :label="item.text" :rules="item.rules.map(x => {return {...getRlDialogRules[x]}[0]})" type="text" autocomplete="off" />
										</v-col>
										<v-col v-if="item.type == 'number'" cols="12">
											<v-text-field v-model="editDialogItem[item.value]" :label="item.text" :rules="item.rules.map(x => {return {...getRlDialogRules[x]}[0]})" type="number" autocomplete="off" />
										</v-col>
										<v-col v-if="item.type == 'select-material'" cols="12">
											<v-select v-model="editDialogItem[item.value]" :items="getMaterialList" item-value="id" item-text="description" :label="item.text" :rules="item.rules.map(x => {return {...getRlDialogRules[x]}[0]})" />
										</v-col>
									</v-row>
								</v-form>
							</v-container>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="primary darken-1" text @click.prevent="editDialogShow = false" :disabled="editDialogLoading">Close</v-btn>
							<v-btn color="primary" @click.prevent="saveEditDialog()" :disabled="editDialogLoading">Save</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>

				<v-dialog v-if="deleteDialogShow" v-model="deleteDialogShow" persistent max-width="500px">
					<v-card>
						<v-card-title>
							<span class="headline">{{ deleteDialogTitle }}</span>
						</v-card-title>
						<v-card-text>
							<v-alert :value="deleteDialogAlert.show" dense outlined type="error" icon="error">{{ deleteDialogAlert.message }}</v-alert>
							<v-progress-linear :active="deleteDialogLoading" height="3" indeterminate absolute color="primary" />
							<v-container>
								<v-row>
									<v-col cols="12">
										<span>The entry will be permanently removed!</span>
									</v-col>
								</v-row>
							</v-container>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="primary darken-1" text @click.prevent="deleteDialogShow = false" :disabled="deleteDialogLoading">Close</v-btn>
							<v-btn color="primary" @click.prevent="saveDeleteDialog()" :disabled="deleteDialogLoading">Delete</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>	
			</v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'

export default {
	name: 'AppSettings',
	data() {
		return {
			licensesHeaders:[
				{text: 'Name', value: 'name', type: 'text', dialogField: true, rules: ['required', 'stringMax255']},
				{text: 'Duration', value: 'duration', type: 'number', dialogField: true, rules: ['required', 'integer']},
				{text: 'Roles', value: 'roles', dialogField: true},
				{text: 'Actions', value: 'actions', sortable: false},
			],
			rolesHeaders: [
				{ text: 'Role Name', value: 'name' },
				{ text: 'Permissions', value: 'permission' },
				{ text: 'Actions', value: 'actions', sortable: false }
			],
			currencyHeaders: [
				{ text: 'Code', value: 'code', dialogField: true, readonly: true, type: 'text', rules: ['required', 'stringSize3']},
				{ text: 'Group', value: 'group_id', dialogField: true, readonly: false, type: 'number', rules: ['required', 'integerOneOrTwo']},
				{ text: 'Actions', value: 'actions', align: 'right', sortable: false}
			],
			countryHeaders: [
				{ text: 'Code', value: 'code', dialogField: true, readonly: true, type: 'text', rules: ['required', 'stringSize2']},
				{ text: 'Name', value: 'name', dialogField: true, readonly: false, type: 'text', rules: ['required', 'stringMax255']},
				{ text: 'Actions', value: 'actions', align: 'right', sortable: false}
			],
			entryTypeHeaders: [
				{ text: 'Description', value: 'description', dialogField: true, readonly: false, type: 'text', rules: ['required', 'stringMax20']},
				{ text: 'Actions', value: 'actions', align: 'right', sortable: false}
			],
			materialHeaders: [
				{ text: 'Description', value: 'description', dialogField: true, readonly: false, type: 'text', rules: ['required', 'stringMax20']},
				{ text: 'Actions', value: 'actions', align: 'right', sortable: false}
			],
			gradeHeaders: [
				{ text: 'Description', value: 'description', dialogField: true, readonly: false, type: 'text', rules: ['required', 'stringMax50']},
				{ text: 'Material ID', value: 'material_id', dialogField: true, readonly: false, type: 'select-material', rules: ['required']},
				{ text: 'Actions', value: 'actions', align: 'right', sortable: false}
			],
			incotermHeaders: [
				{ text: 'Description', value: 'description', dialogField: true, readonly: false, type: 'text', rules: ['required', 'stringMax50']},
				{ text: 'Actions', value: 'actions', align: 'right', sortable: false}
			],
			pbiReportHeaders: [
				{ text: 'Report Id', value: 'report_id', dialogField: true, readonly: false, type: 'number', rules: ['required', 'integer']},
				{ text: 'Report Name', value: 'report_name', dialogField: true, readonly: false, type: 'text', rules: ['required', 'stringMax80']},
				{ text: 'PBI Group Id', value: 'pbi_group_id', dialogField: true, readonly: false, type: 'text', rules: ['required', 'stringMax36']},
				{ text: 'PBI Report Id', value: 'pbi_report_id', dialogField: true, readonly: false, type: 'text', rules: ['required', 'stringMax36']},
				{ text: 'PBI Page Name', value: 'pbi_page_name', dialogField: true, readonly: false, type: 'text', rules: ['required', 'stringMax36']},
				{ text: 'PBI Token Expiration UTC', value: 'pbi_expiration_datetime'},
				{ text: 'Actions', value: 'actions', align: 'right', sortable: false }
			],
			unitOfMeasureHeaders: [
				{ text: 'Code', value: 'code', dialogField: true, readonly: true, type: 'text', rules: ['required', 'stringMax5']},
				{ text: 'Description', value: 'description', dialogField: true, readonly: false, type: 'text', rules: ['required', 'stringMax50']},
				{ text: 'Actions', value: 'actions', align: 'right', sortable: false}
			],
			addLicenseDialogShow: false,
			addedLicense: {},
			addLicenseAlert: {show: false, message: null},
			editLicenseDialogShow: false,
			editedLicense: {name: '', duration: null, roles: {}},
			editLicenseAlert: {show: false, message: null},
			editRoleDialogShow: false,
			editedRole: {name: '', permissions: {}},
			editRoleAlert: {show: false, message: null},
			addEndpoint: null,
			addDialogShow: false,
			addDialogTitle: null,
			addDialogFields: null,
			addDialogLoading: false,
			addDialogSetList: null,
			addDialogItem: {},
			addDialogAlert: {show: false, message: null},		
			editEndpoint: null,
			editDialogShow: false,
			editDialogTitle: null,
			editDialogFields: null,
			editDialogLoading: false,
			editDialogSetList: null,
			editDialogItem: {},
			editDialogAlert: {show: false, message: null},
			deleteEndpoint: null,
			deleteDialogShow: false,
			deleteDialogTitle: null,
			deleteDialogLoading: false,
			deleteDialogSetList: null,
			deleteDialogItem: {},
			deleteDialogAlert: {show: false, message: null},
		} 
	},
	mounted() {		
		this.setLicenseList()
		this.setPermissionList()
		this.setRoleList()
		this.setCurrencyList()
		this.setPBIReportList()
		this.setUnitOfMeasureList()
		this.setMaterialList()
		this.setGradeList()
		this.setCountryList()
		this.setIncotermList()
		this.setEntryTypeList()		
	},
	methods: {
		openAddDialog(title, fields, endpoint, setList) {		
			this.addDialogItem = {}
			this.addDialogTitle = title
			this.addDialogFields = this[fields].filter(x => x.dialogField === true)
			this.addEndpoint = endpoint
			this.addDialogSetList = setList
			this.addDialogShow = true
		},
		async saveAddDialog() {
			if (this.$refs.addDialogForm.validate()) {
				try {
					this.addDialogAlert = { show: false, message: null }
					this.addDialogLoading = true

					const endpoint = 'api/v1/' + this.addEndpoint + '/'
					await axios.post(endpoint, this.addDialogItem)
					
					this.addDialogLoading = false
					this.addDialogShow = false
					this[this.addDialogSetList]()				
				} catch (error) {
					this.addDialogLoading = false
					this.addDialogAlert = { show: true, message: error.response.data.message }
				}
			}
		},
		openEditDialog(title, fields, endpoint, setList, item) {
			if (item) {
				this.editDialogItem = JSON.parse(JSON.stringify(item))
			}
			this.editDialogTitle = title
			this.editDialogFields = this[fields].filter(x => x.dialogField === true)			
			this.editEndpoint = endpoint
			this.editDialogSetList = setList
			this.editDialogShow = true
		},
		async saveEditDialog() {
			if (this.$refs.editDialogForm.validate()) {
				try {
					this.editDialogAlert = { show: false, message: null }
					this.editDialogLoading = true

					const endpoint = 'api/v1/' + this.editEndpoint + '/'

					if (this.editDialogItem.id) {
						await axios.put(endpoint + this.editDialogItem.id, this.editDialogItem)
					} else if (this.editDialogItem.code) {
						await axios.put(endpoint + this.editDialogItem.code, this.editDialogItem)
					}

					this.editDialogLoading = false
					this.editDialogShow = false
					this[this.editDialogSetList]()
				} catch (error) {
					this.editDialogLoading = false
					this.editDialogAlert = { show: true, message: error.response.data.message }
				}
			}
		},
		openDeleteDialog(title, endpoint, setList, item) {
			if (item) {
				this.deleteDialogItem = JSON.parse(JSON.stringify(item))
			}
			this.deleteDialogTitle = title 
			this.deleteEndpoint = endpoint
			this.deleteDialogSetList = setList
			this.deleteDialogShow = true
		},
		async saveDeleteDialog() {			
			try {
				this.deleteDialogAlert = { show: false, message: null }
				this.deleteDialogLoading = true
				
				const endpoint = 'api/v1/' + this.deleteEndpoint + '/'

				if (this.deleteDialogItem.id) {
					await axios.delete(endpoint + this.deleteDialogItem.id)
				} else if (this.deleteDialogItem.code) {
					await axios.delete(endpoint + this.deleteDialogItem.code)
				}

				this.deleteDialogLoading = false
				this.deleteDialogShow = false
				this[this.deleteDialogSetList]()
			} catch (error) {
				this.deleteDialogLoading = false
				this.deleteDialogAlert = { show: true, message: error.response.data.message }
			}			
		},
		openEditRoleDialog(item) {			
			this.editedRole = JSON.parse(JSON.stringify(item))
			this.editRoleDialogShow = true
		},
		async editRole() {
			if (this.$refs.editRoleDialogForm.validate()) {	
				try {
					this.editRoleAlert = { show: false, message: null }
					this.editDialogLoading = true
					await axios.post('api/v1/roles/' + this.editedRole.id + '/permissions', JSON.stringify(this.editedRole.permissions.data.map(x => { return { id: x} })))
					this.editDialogLoading = false
					this.editRoleDialogShow = false
					this.setRoleList()
				} catch (error) {
					this.editDialogLoading = false
					this.editRoleAlert = { show: true, message: error.response.data.message }
				}
			}
		},
		closeAddLicenseDialog() {
			this.addLicenseDialogShow = false
			this.addLicenseAlert = { show: false, message: null }
			this.$refs.addLicenseDialogForm.reset()
		},
		openAddLicensesDialog() {
			this.addLicenseDialogShow = true
		},
		async addLicense() {					
			if (this.$refs.addLicenseDialogForm.validate()) {	
				try {			
					this.addLicenseAlert = { show: false, message: null }
					this.addDialogLoading = true

					const response  = await axios.post('api/v1/licenses', JSON.stringify({ name: this.addedLicense.name, duration: this.addedLicense.duration }))		

					if (response.status === 200 && response.data.message === 'OK' ) {
						await axios.post('api/v1/licenses/' + response.data.license.id + '/roles', JSON.stringify(this.addedLicense.roles.map(x => { return { id: x} })))
					}

					this.addDialogLoading = false
					this.addLicenseDialogShow = false
					this.$refs.addLicenseDialogForm.reset()
					this.setLicenseList()
				} catch(error) {
					this.addDialogLoading = false
					this.addLicenseAlert = { show: true, message: error.response.data.message }
				}
			}
		},
		openEditLicensesDialog(item){	
			this.editedLicense = JSON.parse(JSON.stringify(item))
			this.editLicenseDialogShow = true;
		},
		async editLicense() {			
			if (this.$refs.editLicenseDialogForm.validate()) {	
				try {
					this.editLicenseAlert = { show: false, message: null }
					this.editDialogLoading = true
					await axios.put('api/v1/licenses/' + this.editedLicense.id, JSON.stringify({ name: this.editedLicense.name, duration: this.editedLicense.duration }))
					await axios.post('api/v1/licenses/' + this.editedLicense.id + '/roles', JSON.stringify(this.editedLicense.roles.data.map(x => { return { id: x} })))
					this.editDialogLoading = false
					this.editLicenseDialogShow = false
					this.setLicenseList()
				} catch (error) {
					this.editDialogLoading = false
					this.editLicenseAlert = { show: true, message: error.response.data.message }
				}
			}
		},
		getMaterialById(id) {
			return this.getMaterialList.find(x => x.id === id).description
    },
		...mapActions([
			'setLicenseList',
			'setPermissionList',
			'setRoleList',
			'setCurrencyList',
			'setPBIReportList',
			'setUnitOfMeasureList',
			'setMaterialList',
			'setGradeList',
			'setCountryList',
			'setIncotermList',
			'setEntryTypeList'
		])
	},
	computed: {
    ...mapGetters([
		'getLicenseList',
		'getPermssionList',
		'getRoleList',
		'getCurrencyList',
		'getPBIReportList',
		'getUnitOfMeasureList',
		'getMaterialList',
		'getGradeList',
		'getCountryList',
		'getIncotermList',
		'getRlDialogRules',
		'getEntryTypeList'
		])
  }
}
</script>